import { PropsWithChildren } from 'react';
import * as styles from './StatusBar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Typography, TypographyProps } from '../typography/typography';
import { clsx } from 'clsx';
import { faInfoCircle as faInfoSolid } from '@fortawesome/pro-solid-svg-icons';

type StatusBarProps = {
  icon?: IconProp;
  className?: string;
} & Partial<Pick<TypographyProps, 'variant'>>;

export const StatusBar = (p: PropsWithChildren<StatusBarProps>) => (
  <div className={clsx(styles.statusBarWrapper, p.className)}>
    {p.icon ? (
      <FontAwesomeIcon
        className={styles.iconWrapper}
        icon={p.icon}
        width={16}
        height={16}
      />
    ) : null}
    <div>
      <Typography variant={p.variant || 'bodyLarge'}>{p.children}</Typography>
    </div>
  </div>
);

export const InfoBar = (
  p: PropsWithChildren<{ text?: string; className?: string }>,
) => (
  <StatusBar icon={faInfoSolid} className={p.className}>
    {p.text || p.children}
  </StatusBar>
);
